import { render, staticRenderFns } from "./AddChatChannel.vue?vue&type=template&id=47e746fe"
import script from "./AddChatChannel.vue?vue&type=script&lang=ts"
export * from "./AddChatChannel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports